(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function ggMountCodButtons() {
    document.querySelectorAll('gg-inline-cod-button[data-gg-inline]').forEach(node => {
      const form = document.getElementById(node.dataset.formId);
      const group = form?.querySelector('.product-form__buttons');
      if (group && node.parentElement !== group) group.appendChild(node);
    });
  }
  ggMountCodButtons();
  document.addEventListener('shopify:section:load', ggMountCodButtons);

  if (!customElements.get('gg-inline-cod-button')) {
    customElements.define('gg-inline-cod-button', class extends HTMLElement {
      connectedCallback() {
        if (this.ggInitialized) return;
        this.ggInitialized = true;
        this.button = this.querySelector('button');
        this.label = this.querySelector('.gg-cod__label');
        this.status = this.querySelector('.gg-cod__status');
        this.fallback = this.querySelector('.gg-cod__fallback');
        this.defaultLabel = this.label.textContent;
        this.onClick = this.start.bind(this);
        this.button.addEventListener('click', this.onClick);
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
        this.visibility = new IntersectionObserver(entries => { this.dataset.visible = String(entries[0].isIntersecting && !document.hidden); });
        this.visibility.observe(this);
        this.onVisibility = () => { this.dataset.visible = String(!document.hidden && this.getBoundingClientRect().bottom > 0 && this.getBoundingClientRect().top < innerHeight); };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.sync();
      }
      disconnectedCallback() {
        this.ggInitialized = false;
        this.observer?.disconnect();
        this.visibility?.disconnect();
        this.button?.removeEventListener('click', this.onClick);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
      sync() {
        this.form = document.getElementById(this.dataset.formId);
        this.nativeButton = this.form?.querySelector('button[name="add"]');
        const bundleReady = !!this.form?.querySelector('.kaching-bundles__block--loaded');
        document.getElementById('MainProduct-' + this.dataset.sectionId)?.classList.toggle('gg-cod-bundle-ready', bundleReady);
        const ready = !!this.nativeButton && !!this.form?.querySelector('.kaching-bundles__block--loaded') && !!document.querySelector('.es-popup-button-drawer');
        this.hidden = !ready;
        const disabled = !!this.busy || !this.nativeButton || this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
        if (this.button.disabled !== disabled) this.button.disabled = disabled;
      }
      async readCart() {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 6000);
        try {
          const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('cart');
          return await response.json();
        } finally { clearTimeout(timeout); }
      }
      productQuantity(cart) {
        return cart.items.filter(item => String(item.product_id) === this.dataset.productId).reduce((sum, item) => sum + item.quantity, 0);
      }
      giftReady(cart) {
        const gift = cart.items.find(item => item.sku === 'GG-SURPRIZ-HEDIYE');
        const paidQuantity = cart.items.filter(item => item.sku !== 'GG-SURPRIZ-HEDIYE' && item.original_price > 0).reduce((sum, item) => sum + item.quantity, 0);
        return paidQuantity < 2 || (gift && gift.quantity === 1);
      }
      async openOrderForm() {
        const trigger = document.querySelector('.es-popup-button-drawer');
        if (!trigger) throw new Error('form');
        trigger.click();
        for (let attempt = 0; attempt < 20; attempt++) {
          await new Promise(resolve => setTimeout(resolve, 150));
          const modal = document.querySelector('#easysell-modal');
          if (modal && modal.getBoundingClientRect().height > 0 && getComputedStyle(modal).display !== 'none') return;
        }
        throw new Error('form');
      }
      async start() {
        if (this.busy || this.button.disabled) return;
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        this.status.textContent = '';
        this.fallback.hidden = true;
        this.label.textContent = this.dataset.loading;
        let submitted = false;
        try {
          if (this.pendingCart) {
            await this.openOrderForm();
            this.pendingCart = false;
            return;
          }
          const before = await this.readCart();
          const quantity = this.productQuantity(before);
          if (!this.nativeButton || this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true') throw new Error('unavailable');
          submitted = true;
          this.nativeButton.click();
          const deadline = Date.now() + 20000;
          let previous = '';
          while (Date.now() < deadline && this.isConnected) {
            await new Promise(resolve => setTimeout(resolve, 500));
            const error = this.form?.closest('product-form')?.querySelector('.product-form__error-message-wrapper:not([hidden])');
            if (error?.textContent.trim()) throw new Error('add');
            const cart = await this.readCart();
            const added = this.productQuantity(cart) > quantity;
            const signature = JSON.stringify(cart.items.map(item => [item.key, item.quantity, item.final_line_price]));
            const drawer = document.querySelector('cart-drawer.active');
            if (added && this.giftReady(cart) && drawer && signature === previous) {
              this.pendingCart = true;
              await this.openOrderForm();
              this.pendingCart = false;
              return;
            }
            previous = signature;
          }
          throw new Error('timeout');
        } catch (error) {
          if (submitted || this.pendingCart) {
            this.pendingCart = true;
            this.status.textContent = this.dataset.cartError;
            this.fallback.hidden = false;
          } else this.status.textContent = this.dataset.error;
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.label.textContent = this.pendingCart ? this.dataset.retry : this.defaultLabel;
          this.sync();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
